import logo from "./logo.svg";
import "./App.css";
import { useState } from "react";
import Sidebar from "./Components/Sidebar";
import { makeStyles } from "@material-ui/core/styles";
import { Drawer } from "@material-ui/core";
import { v4 as uuid } from "uuid";

const useStyles = makeStyles((theme) => ({
  hide: {
    display: "none",
  },
  drawer: {
    // width: drawerWidth,
  },

  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  para: {
    fontFamily: "Poppins,sans-serif",
  },
  btnHolder: { position: "absolute", right: 0, bottom: 0, margin: "10px" },
  mypara: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Poppins,sans-serif",
  },
}));

function App() {
  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  let [chartsArr, setChartsArr] = useState([
    {
      id: uuid(),
      sender: "bot",
      message: "Welcome to chatbot",
    },
  ]);
  const classes = useStyles();

  return (
    <div className="App">
      <header className="App-header">
        <div className="main-wrapper">
          <p className={classes.mypara}>
            WELCOME TO <img src={logo} className="App-logo" alt="logo" />
          </p>
          <div>
            <p className={classes.para}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
          </div>
          <div className={classes.btnHolder}>
            <img
              src={logo}
              alt="logo"
              className="sidebar-logo"
              onClick={() => {
                setIsOpenSidebar(true);
              }}
              title="Ask Me"
            />
          </div>
        </div>
        <div className="drawer-div">
          {isOpenSidebar && (
            <Drawer
              className="drawerPaper"
              variant="persistent"
              anchor="right"
              open={isOpenSidebar}
              classes={{
                paper: classes.drawerPaper2,
              }}
            >
              <Sidebar
                setIsOpenSidebar={setIsOpenSidebar}
                isOpenSidebar={isOpenSidebar}
                chartsArr={chartsArr}
                setChartsArr={setChartsArr}
              />
            </Drawer>
          )}
        </div>
      </header>
    </div>
  );
}

export default App;
